import SingleModelStore from './SingleModelStore';

export default SingleModelStore.create();



// WEBPACK FOOTER //
// ./src/EditModel/modelToEditStore.js